export function constructTableRequestParams(filters = {},pageable = {}){
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        //checks also undefined
        if(value == null || value === '')return;

        if(Array.isArray(value)) {
            value.forEach((value) => {
                params.append(key, value);
            })
        }else {
            params.append(key,value);
        }

    })

    Object.entries(pageable).forEach(([key, value]) => {
        if(!value)return;

        params.append(key,value)
    })

    return params
}


// WEBPACK FOOTER //
// ./src/services/statistics/util.js